module.exports = __webpack_public_path__ + "static/img/06.b1e45deb.png";